<template>
  <div class="benefits-nav">
    <ul class="benefits-nav__dots">
      <li
        class="benefits-nav__dot"
        v-for="n in count"
        :key="n"
        :class="{'benefits-nav__dot--active': n === activeIndex + 1}"
      ></li>
    </ul>
    <span class="benefits-nav__label">{{label}}</span>
  </div>
</template>

<script>
export default {
  name: 'BenefitsNav',
  props: {
    label: String,
    count: Number,
    activeIndex: Number,
  },
};
</script>

<style lang="scss">
@import '../styles/helpers';

.benefits-nav {
  display: block;
  position: fixed;
  right: 40px;
  top: 200px;
  transform: translateX(100%);

  &__dots {
    display: block;
    list-style: none;
    padding: 0;
    margin: 0;
  }

  &__dot {
    display: block;
    width: 8px;
    height: 8px;
    margin-bottom: 20px;
    border-radius: 4px;
    background: $c_grey--dark;
    transition: background .35s;

    &--active {
      background: $c_purple;
    }
  }

  &__label {
    display: block;
    transform-origin: 100% 0;
    transform: translateX(-100%) rotate(-90deg);
    color: $c_grey--dark;
    font-size: 14px;
    line-height: 8px;
    font-weight: $t_light;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BenefitsNav.vue